<template>
  <span>
    <b-card no-body>
      <b-card-header>
         <b-row>
          <b-col md="9">
            <h3>Gerenciar Perguntas Frequentes</h3>
          </b-col>
          <b-col md="3">
            <p><b>Nome:</b> {{ usuario.nome }}</p>
            <p><b>Perfil:</b> {{ usuario.perfil.nome }}</p>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="4">
            <b-form-group>
              <b-form-group label="Perfil:">
                <b-form-select  v-model="filtros.perfil" class="mb-3">
                  <option selected :value="null">Selecione</option>
                  <option
                    v-for="item in listacombo"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.nome }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-form-group>
          </b-col>
          <b-col offset-sm="6" sm="2">
            <b-button class="mt-3" @click="navigate('/faqs/novo')" block variant="primary">
              <i class="fa fa-plus"></i>
              <span>Nova Pergunta</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group label="Pergunta ou Resposta:">
              <b-form-input
                type="text"
                id="name"
                v-model="filtros.filter"
                placeholder="Pergunta ou Resposta"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-button @click="limpafiltro" block variant="cinza">
              <i class="fa fa-eraser"></i>
              <span>Limpar filtros</span>
            </b-button>
          </b-col>
          <b-col md="2">
            <b-button @click="pesquisar" block variant="primary">
              <i class="fa fa-search"></i>
              <span>Pesquisar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <b-row>
        <b-col sm="12">
          <b-container fluid>
            <span>
              <b-form-select style="width: 100px; float: right" class="mb-3" v-model="totalPorPagina" :options="totalSelectOp"></b-form-select>
              <table
                aria-rowcount="4"
                id="my-table"
                aria-busy="false"
                aria-colcount="7"
                class="
                  table
                  table-responsive-sm
                  table-bordered
                  table-striped
                  table-sm
                "
              >
                <thead>
                  <tr>
                    <th scope="col">Perfil</th>
                    <th scope="col">Pergunta</th>
                    <th scope="col">Resposta</th>
                    <th scope="col">Ordem de exibição</th>
                    <th scope="col">Situação</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="faqs.data !== undefined">
                  <tr v-for="faq in faqs.data" :key="faq.id">
                    <td>{{ Tratar(faq.perfil) }}</td>
                    <td>{{ faq.pergunta }}</td>
                    <td style="width: 15%">
                      <a
                        class="btn btn-sm btn-secondary action"
                        title="Visualizar Resposta"
                        @click="openModal(faq.id)"
                      >
                        <i class="fa fa-eye"></i>
                      </a>
                    </td>
                    <td>{{ faq.ordem_exibicao }}</td>
                    <td>{{ faq.ativo ? "Ativo" : "Inativo" }}</td>
                    <td style="width: 15%">
                      <a
                        class="btn btn-sm btn-secondary action"
                        title="Visualizar faq"
                        @click="visualizar(faq.id)"
                      >
                        <i class="fa fa-eye"></i>
                      </a>
                      <a
                        class="btn btn-sm btn-secondary action"
                        title="Editar faq"
                        @click="editarCaptcha(faq.id)"
                      >
                        <i class="fa fa-pencil-square-o"></i>
                      </a>
                      <a
                        class="btn btn-sm btn-secondary action"
                        title="Excluir faq"
                        @click="excluirfaq(faq.id)"
                      >
                        <i class="fa fa-times"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="6">Nenhum registro de faqs...</td>
                  </tr>
                </tbody>
              </table>
              <pagination
                v-show="faqs.data !== undefined"
                :totalPorPagina="totalPorPagina"
                :resource="resource"
                :filtros="filtros"
              ></pagination>
            </span>
          </b-container>
        </b-col>
      </b-row><b-modal title="Resposta" :hide-footer="true" hide-header-close v-model="modal">
            <b-card-body>
                 <b-col sm="12" id="modalbody" class="text-center">
                    {{descricao}}
                 </b-col>
           </b-card-body>
           <b-card-footer class="p-12 text-center">
                <b-button variant="secondary" @click="fecharModal"><i class="fa fa-times">&nbsp;</i> Fechar</b-button>
           </b-card-footer>
        </b-modal>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import { eventType } from '@/components/shared/eventType'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'A') {
      this.$store.dispatch('getAdministradores')
      this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
    } else {
      this.$router.push('/faqs/list')
    }
  },
  data () {
    return {
      mainProps: { width: 250, height: 250 },
      videoSimular: '',
      modal: false,
      descricao: '',
      respostaFinal: false,
      countadorErros: 0,
      tentativas: 1,
      respostaErrada: false,
      respostaCerta: false,
      modalSimular: false,
      totalPorPagina: 20,
      totalSelectOp: [
        {text: '20', value: 20},
        {text: '30', value: 30},
        {text: '50', value: 50},
        {text: '100', value: 100}
      ],
      resource: 'faqs',
      listacombo: [
        {
          id: 1,
          nome: 'Público Geral'
        },
        {
          id: 2,
          nome: 'Voluntária'
        },
        {
          id: 3,
          nome: 'Beneficiária'
        }
      ],
      filtros: {
        filter: '',
        perfil: null
      },
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: '',
        nome: ''
      }
    }
  },
  computed: {
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    administradores () {
      return this.$store.state.usuario.administradores
    },
    faqs () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    }
  },
  watch: {
    'usuario.perfil': function () {
      this.usuarioLogado.perfil = this.usuario.perfil.nome
      this.usuarioLogado.nome = this.usuario.nome
    }
  },
  methods: {
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    pesquisar () {
      this.$store.dispatch('getRegistrosSearch', {
        resource: this.resource,
        limit: this.totalPorPagina,
        filtros: this.filtros
      })
      this.setarFiltros(this.filtros)
    },
    limpafiltro () {
      this.filtros = {
        filter: '',
        perfil: null
      }
      this.pesquisar()
    },
    Tratar (perfis) {
      let perfisTratados = ''
      this.listacombo.forEach(element => {
        if (perfis.includes(element.id)) { perfisTratados += ', ' + element.nome }
      })
      return perfisTratados.replace(/^./, '')
    },
    fecharModal () {
      this.modal = false
    },
    openModal (id) {
      Vue.http.get('api/faqs/' + id).then(response => {
        this.descricao = response.body.data[0].resposta
      })
      this.modal = true
    },
    visualizar (id) {
      this.$router.push('/faqs/visualizar/' + id)
    },
    editarCaptcha (id) {
      this.$router.push('/faqs/edit/' + id)
    },
    excluirfaq (id) {
      this.$bvModal
        .msgBoxConfirm('Deseja realmente excluir esse faq?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            Vue.http
              .delete('api/faqs/' + id)
              .then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch('getRegistrosSearch', {
                    resource: this.resource,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
              .catch((erro) => {
                if (!erro.body.success) {
                  miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
                  miniToastr.error(erro.body.msg, 'Alerta!', 7000)
                  this.$store.dispatch('getRegistrosSearch', {
                    resource: this.resource,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
          }
        })
        .catch((erro) => {
          console.log(erro)
        })
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
.action {
  cursor: pointer;
}
#modalbody{
  font-size: 15pt;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/faq/Faq.vue